import type { UserData } from '@/store/profile.store';

export function mergeEmailVerificationUser(
  currentUser: UserData | null,
  nextUser: Partial<UserData> & { email?: string | null },
): UserData {
  const nextEmail =
    typeof nextUser.email === 'string' ? nextUser.email : (currentUser?.email ?? '');

  return {
    id: currentUser?.id ?? nextUser.id ?? '',
    name: currentUser?.name ?? '',
    ...currentUser,
    ...nextUser,
    email: nextEmail,
  };
}
